import React from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import {
  TIPOS_DOCUMENTO,
  formatDocumento,
  placeholderDocumento,
  maxLengthDocumento,
} from "lib/documento";

/**
 * Campo de documento de identidad con selector de tipo (Cédula / RNC /
 * Pasaporte) como adorno. El valor se guarda en la misma columna `cedula`
 * de siempre; el tipo solo controla la máscara y la validación en el
 * cliente. Al cambiar el tipo se re-formatea el valor digitado.
 */
export default function DocumentoField({
  value,
  tipo,
  onChangeValor,
  onChangeTipo,
  label = "Documento",
  ...rest
}) {
  return (
    <TextField
      fullWidth
      label={label}
      value={value}
      onChange={(e) => onChangeValor(formatDocumento(e.target.value, tipo))}
      placeholder={placeholderDocumento(tipo)}
      inputProps={{ maxLength: maxLengthDocumento(tipo) }}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <TextField
              select
              variant="standard"
              value={tipo}
              onChange={(e) => {
                const t = e.target.value;
                onChangeTipo(t);
                onChangeValor(formatDocumento(value, t));
              }}
              InputProps={{ disableUnderline: true }}
              sx={{
                minWidth: 86,
                "& .MuiSelect-select": { fontSize: 13, fontWeight: 600, py: 0.25 },
              }}
            >
              {TIPOS_DOCUMENTO.map((t) => (
                <MenuItem key={t.value} value={t.value}>
                  {t.label}
                </MenuItem>
              ))}
            </TextField>
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  );
}
